import { NeuronsBadge } from '~components/NeuronsBadge';
import type { TMedia } from '~constants/media';
import { liquidAnimation, paidPreviewAnimation } from '~theme/snippets';

import type { TMessage } from '../../model/types';
import { PrivateChatImage } from '../PrivateChatImage';
import { PaidImageInner, PaidImageWrapper } from './styles';

export const PaidImageMessage: React.FC<{
	message: TMessage;
	media: TMedia[];
	action?: () => void;
	showPrice?: boolean;
	className?: string;
	showText?: boolean;
	showPreview?: boolean;
}> = ({ message, media, action, showPrice = false }) => {
	const { meta } = message;

	return (
		<PaidImageWrapper onClick={action} className={liquidAnimation}>
			<PaidImageInner className={paidPreviewAnimation}>
				<PrivateChatImage
					media={media}
					fallbackUrl={meta?.preview as string}
					height={160}
					showPreview={true}
					width={160}
					quality={75}
				/>
				<NeuronsBadge cost={meta?.tariffication?.cost} showPrice={showPrice} />
			</PaidImageInner>
		</PaidImageWrapper>
	);
};
